import { useUpsertManyReports } from "@/reports/api/upsert";
import { Status } from "@/reports/config/status";
import {
  ManualValveReport,
  SafetyValveReport,
} from "@/reports/types/SafetyValveReport";
import { Location } from "@/reports/config/locations";
import { ReportType } from "../types/Api";

interface Props {
  reportType: ReportType;
}

const useBulkChangeReportStatus = ({ reportType }: Props) => {
  const { mutateAsync: upsertManyReports } = useUpsertManyReports(reportType);

  const changeStatus = async (
    reports: (SafetyValveReport | ManualValveReport)[],
    newStatus: Status,
    location: Location | undefined
  ) => {
    const commonFields = {
      // these fields are not allowed in the API
      createdAt: undefined,
      updatedAt: undefined,
      createdBy: undefined,
      updatedBy: undefined,
      Attachments: undefined,
      NewAddedAttachments: undefined,
      DeletedAttachments: undefined,
      ManualValveRepairReportAttachments: undefined,

      location,
      // status is the only field that we want to change
      status: newStatus,
    };

    const stringifiedMultipleReportsValues = JSON.stringify(
      reports.map((report) => ({
        ...report,
        ...commonFields,
      }))
    );

    const formData = new FormData();
    formData.append("reports", stringifiedMultipleReportsValues);

    try {
      const {
        data: { result },
      } = await upsertManyReports(formData);

      // if any of the reports were updated, return true
      if (result.some((item) => item.updated.length > 0)) return true;
      return false;
    } catch {
      return false;
    }
  };

  return {
    changeStatus,
  };
};

export default useBulkChangeReportStatus;
